import { render, staticRenderFns } from "./OrdersTableEmptyState.vue?vue&type=template&id=4a88e599&scoped=true&"
import script from "./OrdersTableEmptyState.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OrdersTableEmptyState.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88e599",
  null
  
)

export default component.exports